import { render, staticRenderFns } from "./CreateLeadButton.vue?vue&type=template&id=5b2190a8&"
import script from "./CreateLeadButton.vue?vue&type=script&lang=ts&"
export * from "./CreateLeadButton.vue?vue&type=script&lang=ts&"
import style0 from "./CreateLeadButton.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports